export const SITE_URL = "https://snapcards.ai";

export const SUPPORTED_FORMATS = ["pdf", "docx"] as const;

export const PLAN_LIMITS = {
  free: {
    pdfsPerMonth: 5,
    ankiExport: false,
    cardExplanations: true,
    sourceDeeplink: false,
    maxDecks: 3,
    sessionSize: 10,
    chatMessagesPerDay: 10,
    cardCeiling: 80,
    formats: SUPPORTED_FORMATS,
  },
  pro: {
    pdfsPerMonth: Infinity,
    ankiExport: true,
    cardExplanations: true,
    sourceDeeplink: true,
    maxDecks: Infinity,
    sessionSize: 50,
    chatMessagesPerDay: Infinity,
    cardCeiling: 300,
    formats: SUPPORTED_FORMATS,
  },
  team: {
    pdfsPerMonth: Infinity,
    ankiExport: true,
    cardExplanations: true,
    sourceDeeplink: true,
    maxDecks: Infinity,
    sessionSize: 50,
    chatMessagesPerDay: Infinity,
    cardCeiling: 300,
    formats: SUPPORTED_FORMATS,
    members: 5,
  },
} as const;

export type SubscriptionTier = keyof typeof PLAN_LIMITS;

export const CHAT_PER_MINUTE_LIMIT = 10;
export const MAX_USER_MESSAGE_CHARS = 1000;
